import React from 'react';
import { Button } from '../button/Button';
import { Icon } from '../icon/Icon';
import { mcNew } from '@mc/react-ui-icons';
import { Classes } from '../index';
type Props = {
  onClick?: (a: any) => void;
};
export const CalendarFixedPlusButton: React.FC<Props> = ({ onClick }) => {
  return (
    <Button
      dataTest={'global-add'}
      className={Classes.CALENDAR_FIXED_PLUS}
      icon={<Icon fixedWidth size="2x" icon={mcNew} />}
      style="primary"
      onClick={onClick}
    />
  );
};
